import { render, staticRenderFns } from "./notice-list.vue?vue&type=template&id=879098b2&scoped=true&"
import script from "./notice-list.vue?vue&type=script&lang=js&"
export * from "./notice-list.vue?vue&type=script&lang=js&"
import style0 from "./notice-list.vue?vue&type=style&index=0&id=879098b2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879098b2",
  null
  
)

export default component.exports